import { createBrowserRouter } from 'react-router-dom';

import { AuthGuard } from '@/components/auth';
import { Shell } from '@/components/layout';

import type { RouteObject } from 'react-router-dom';

const loginRoute: RouteObject = {
  path: '/login',
  lazy: async () => {
    const { LoginPage } = await import('@/pages/LoginPage');
    return { Component: LoginPage };
  },
};

const homeRoute: RouteObject = {
  index: true,
  lazy: async () => {
    const { HomePage } = await import('@/pages/HomePage');
    return { Component: HomePage };
  },
};

export function createAppRouter(
  routes: RouteObject[]
): ReturnType<typeof createBrowserRouter> {
  return createBrowserRouter([
    loginRoute,
    {
      element: <AuthGuard />,
      children: [
        { path: '/', element: <Shell />, children: [homeRoute, ...routes] },
      ],
    },
  ]);
}
